import TranslateSubcategory from "@/views/admin/translate/TranslateSubcategory";

export default {
  path: "translate/subcategory",
  name: "TranslateSubcategory",
  component: TranslateSubcategory,
  props: true,
  meta: {
    requiresAuth: true,
    owner: true
  }
};
